import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IPlayerError } from 'src/interfaces/PlayerError';
import { SELECTOR_PLAYER_ERROR, PlayerErrorActionTypes } from 'src/store/reducers/playerError';
import ApplicationService from 'src/services/ApplicationService';
import { DatahubEntity, ErrorAction } from 'src/interfaces/Datahub';
import useTracking from '../useTracking';

const usePlayerError = () => {
  const error = useSelector(SELECTOR_PLAYER_ERROR);
  const dispatch = useDispatch();
  const { trackDatahub } = useTracking();

  const setError = useCallback((error: IPlayerError) => {
    dispatch({ type: PlayerErrorActionTypes.SET_PLAYER_ERROR, payload: error });
  }, []);

  const handleCatchError = useCallback(() => {
    const errorMessage = ApplicationService.player?.getErrorMessage();
    if (errorMessage) {
      setError(errorMessage);
      trackDatahub(DatahubEntity.ERROR, ErrorAction.MEASURE, errorMessage);
      ApplicationService.player?.pause();
    }
  }, []);

  return {
    error,
    setError,
    handleCatchError,
  };
};

export default usePlayerError;
